<template>
  <nav class="sidenav-list">
    <p class="nav-section" v-show="!collapsed">CLIENTES Y MEMBRESÍAS</p>

    <SidenavCollapse navText="Membresías" :to="{ name: ROUTES.MEMBERSHIPS }" :collapsed="collapsed">
      <template #icon><i class="fas fa-id-card"></i></template>
    </SidenavCollapse>

    <SidenavCollapse navText="Credenciales" :to="{ name: ROUTES.CREDENCIALES_PORTALES }" :collapsed="collapsed">
      <template #icon><i class="fas fa-key"></i></template>
    </SidenavCollapse>

    <SidenavCollapse navText="Lonjas" :to="{ name: ROUTES.LONJAS }" :collapsed="collapsed">
      <template #icon><i class="fas fa-building"></i></template>
    </SidenavCollapse>

    <div class="nav-divider" v-show="!collapsed"></div>
    <p class="nav-section" v-show="!collapsed">SERVICIO AL CLIENTE</p>

    <SidenavCollapse navText="PQR" :to="{ name: ROUTES.PQR }" :collapsed="collapsed">
      <template #icon><i class="fas fa-headset"></i></template>
    </SidenavCollapse>

    <SidenavCollapse navText="Eliminar inmuebles" :to="{ name: ROUTES.PROPERTIES_BULK_DELETE }" :collapsed="collapsed">
      <template #icon><i class="fas fa-trash-alt"></i></template>
    </SidenavCollapse>

    <SidenavCollapse navText="Transacciones" :to="{ name: ROUTES.PLATAFORMA_NEGOCIOS }" :collapsed="collapsed">
      <template #icon><i class="fas fa-handshake"></i></template>
    </SidenavCollapse>

    <SidenavCollapse navText="Reputación de inmuebles" :to="{ name: ROUTES.REPUTACION_INMUEBLES }" :collapsed="collapsed">
      <template #icon><i class="fas fa-star-half-alt"></i></template>
    </SidenavCollapse>

    <div class="nav-divider" v-show="!collapsed"></div>
    <p class="nav-section" v-show="!collapsed">TECNOLOGÍA E INTEGRACIONES</p>

    <SidenavCollapse navText="Integraciones" :to="{ name: ROUTES.EXTERNAL_CREDENTIALS }" :collapsed="collapsed">
      <template #icon><i class="fas fa-plug"></i></template>
    </SidenavCollapse>

    <SidenavCollapse navText="Consumo de IA" :to="{ name: ROUTES.AI_USAGE }" :collapsed="collapsed">
      <template #icon><i class="fas fa-microchip"></i></template>
    </SidenavCollapse>

    <SidenavCollapse navText="Importaciones" :to="{ name: ROUTES.IMPORTACIONES }" :collapsed="collapsed">
      <template #icon><i class="fas fa-file-import"></i></template>
    </SidenavCollapse>

    <SidenavCollapse navText="Reporte de Importaciones" :to="{ name: ROUTES.IMPORTACIONESREPORTE }" :collapsed="collapsed">
      <template #icon><i class="fas fa-chart-bar"></i></template>
    </SidenavCollapse>

    <div class="nav-divider" v-show="!collapsed"></div>
    <p class="nav-section" v-show="!collapsed">CONFIGURACIÓN</p>

    <SidenavCollapse navText="Planes" :to="{ name: ROUTES.PLANS }" :collapsed="collapsed">
      <template #icon><i class="fas fa-layer-group"></i></template>
    </SidenavCollapse>

    <SidenavCollapse navText="Localidades" :to="{ name: ROUTES.LOCALIDADES }" :collapsed="collapsed">
      <template #icon><i class="fas fa-map-marked-alt"></i></template>
    </SidenavCollapse>

    <SidenavCollapse navText="Roles y permisos" :to="{ name: ROUTES.ROLES }" :collapsed="collapsed">
      <template #icon><i class="fas fa-user-shield"></i></template>
    </SidenavCollapse>

    <SidenavCollapse navText="Opciones" :to="{ name: ROUTES.OPTIONS }" :collapsed="collapsed">
      <template #icon><i class="fas fa-cog"></i></template>
    </SidenavCollapse>

    <template v-if="puedeVerPlataforma">
      <div class="nav-divider" v-show="!collapsed"></div>
      <p class="nav-section" v-show="!collapsed">PLATAFORMA</p>

      <SidenavCollapse navText="Auditoría" :to="{ name: ROUTES.PLATAFORMA_AUDITORIA }" :collapsed="collapsed">
        <template #icon><i class="fas fa-clipboard-list"></i></template>
      </SidenavCollapse>

      <SidenavCollapse navText="Roles de plataforma" :to="{ name: ROUTES.PLATAFORMA_ROLES }" :collapsed="collapsed">
        <template #icon><i class="fas fa-user-lock"></i></template>
      </SidenavCollapse>
    </template>
  </nav>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import ROUTES from '../../constansRoute'
import { PLATAFORMA_AUDITORIA_VIEWERS } from '../../constans'
import SidenavCollapse from './SidenavCollapse.vue'

export default {
  name: 'SidenavList',
  components: { SidenavCollapse },
  props: {
    collapsed: { type: Boolean, default: false },
  },
  setup() {
    const store = useStore()

    // Al recargar la pagina el userdata del login se pierde
    if (store.getters['appAuth/isAuthenticated'] && !store.getters['appUserdata/getUser']?.email) {
      store.dispatch('appUserdata/getUserdata').catch(() => null)
    }

    const puedeVerPlataforma = computed(() => {
      const email = (store.getters['appUserdata/getUser']?.email || '').toLowerCase()
      return !!email && PLATAFORMA_AUDITORIA_VIEWERS.includes(email)
    })

    return { ROUTES, puedeVerPlataforma }
  },
}
</script>

<style scoped>
.sidenav-list {
  display: flex;
  flex-direction: column;
}

.nav-section {
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  color: rgba(255, 255, 255, 0.35);
  text-transform: uppercase;
  padding: 12px 20px 4px;
  margin: 0;
}

.nav-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.08);
  margin: 8px 12px 4px;
}
</style>
